<template>
    <header v-cloak>
        <a class="logo" :class="{'hide':!sidebar.opened}" href="javascript:void(0)">
            俺来也合作平台
        </a>
        <span class="hide-menu cursor" @click="toggleSideBar">
            <i class="iconfont icon-menu"></i>
        </span>
        <el-menu class="el-menu-demo" :default-active="$route.path" mode="horizontal" text-color="#fff">
            <!--<el-menu-item index="/dashboard/notice">-->
                <!--<i class="iconfont icon-gonggao mr5"></i>-->
                <!--<router-link to="/dashboard/notice">系统公告</router-link>-->
            <!--</el-menu-item>-->
            <el-submenu index="2">
                <template slot="title">
                    <img :src="avatar" v-if="avatar" class="avatar" width="35" height="35">
                    <img src="../images/default-avatar.png" v-if="!avatar" class="avatar" width="35" height="35">
                    <span style="color: rgba(0, 0, 0, 0.65);">{{username}}{{accountInfo.pid == 0?'':'[子账号]'}}</span>
                </template>
                <el-menu-item v-if="accountInfo.pid == 0">
                    <i class="el-icon-document"></i>
                    <router-link to="/passport/account">账号管理</router-link>
                </el-menu-item>
                <el-menu-item>
                    <i class="el-icon-setting"></i>
                    <router-link to="/passport/changepwd">修改密码</router-link>
                </el-menu-item>
                <el-menu-item @click="logout()">
                    <i class="iconfont icon-loginout pr10"></i>
                    <span style="color: #333;">退出</span>
                </el-menu-item>
            </el-submenu>
        </el-menu>
    </header>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'header1',
        data() {
            return {
                accountInfo: JSON.parse(localStorage.getItem('accountInfo'))
            };
        },
        //components: { ElTopNav },
        computed: {
            ...mapGetters([
                'username',
                'avatar',
                'sidebar'
            ])
        },
        methods: {
            //退出
            logout(){
                this.$store.dispatch('LogOut');
            },
            //操作左导航
            toggleSideBar(){
                this.$store.dispatch('ToggleSideBar')
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Header.vue?0b46aa98